module.exports = __webpack_public_path__ + "media/images/japan_heritage_hikone_castle-ba6804ec046876f0a8a34e701f22473c.png";